/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getIncident} from '../api'

 export const useQueryGetIncident = createReactQueryHook('getIncident', getIncident)
